import { Author } from "../types";

function sortByAuthorAscending<Element extends Author>(
  current: Element,
  next: Element,
): number {
  return current.author.localeCompare(next.author);
}

function sortByAuthorDescending<Element extends Author>(
  current: Element,
  next: Element,
): number {
  return next.author.localeCompare(current.author);
}

export { sortByAuthorAscending, sortByAuthorDescending };
